import React, { useContext, useEffect, useRef, useState } from "react";
import ALoader from "views/pages/manage/common/a-loader";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { useHistory } from "react-router";
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import ListComponent from "./ListComponent";
import styles from "./styles.module.scss";
import { FILTER__FORM_FIELDS_GLOBAL, getCreateUpdateReqBody } from "./constant";
import APopover from "views/pages/manage/common/a-popover";
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import FilterForm from "./FilterForm";
import { updateRequest } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { checkPermission } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { RolePermissions } from "appContext";
import { PermissionContext } from "appContext";
import { pages } from "views/pages/manage/common/constant";

const TransferValidationConfig = ({
    isBranchLevelConfig = false,
    dropdownData,
    dropdownDataLoading
}) => {
    const userPermissions = RolePermissions(useContext(PermissionContext), pages['transferValidationConfig']['id'])

    const [loader, setLoader] = useState(false);
    const [rows, setRows] = useState([]);
    const [isNew, setIsNew] = useState(false);
    const history = useHistory();
    const listRef = useRef();
    const [globalFilter, setGlobalFilter] = useState({
        ...FILTER__FORM_FIELDS_GLOBAL,
    });
    const [filterCount, setFilterCount] = useState(
        getFilterCount(
            { ...globalFilter },
            !isBranchLevelConfig ? ['businessArea'] : []
        )
    );

    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 0,
        totalPage: 0,
        totalRecords: 0,
    });
    const [currPageSize, setCurrentPageSize] = useState(50);


    const applyFilterHandler = (pageNumber = 0, reqObj = {}) => {
        const itemVal = updateRequest(reqObj);
        const { careerIds, businessAreaIds } = itemVal;
        const filterObj = {
            ...(careerIds && { careerIds }),
            businessAreaIds: isBranchLevelConfig
                ? businessAreaIds ?? []
                : [0],
        };
        fetchList(filterObj, pageNumber, currPageSize, true);
    };


    const fetchList = async (reqObj = {}, pageNumber = 0, pageSize = currPageSize, isFilterApplied) => {
        try {
            setLoader(true);
            if (!isFilterApplied) {
                reqObj = {
                    ...reqObj, businessAreaIds: isBranchLevelConfig ? dropdownData?.businessArea?.map(bu => bu?.value)
                        : [0]
                }
            }
            const resp = await fetchAllPostPromisedData(
                `${endpoint.TransferValidationConfig.search}`,
                { ...reqObj, pageNo: pageNumber, pageSize: pageSize },
                "post"
            );

            if (resp?.code === 200) {
                const updatedData = resp?.data?.transferValidationsConfigs?.map(
                    ({
                        businessGroupId,
                        businessAreaId,
                        companyCodeId,
                        academicCareerId,
                        minimumItemType,
                        programActions,
                        ...rest
                    }) => ({
                        ...rest,
                        businessArea: dropdownData?.businessArea?.find(bu => bu?.value == businessAreaId),
                        businessGroup: dropdownData?.businessGroup?.find(bg => bg?.value == businessGroupId),
                        academicCareer: dropdownData?.academicCareer?.find(ac => ac?.value == academicCareerId),
                        companyCode: dropdownData?.companyCode?.find(cCode => cCode?.value == companyCodeId),
                        minimumItemType: dropdownData?.minimumItemType?.find(mi => mi?.label == minimumItemType),
                        programActions: dropdownData?.programActions?.filter(pa => programActions?.includes(pa?.label)),
                    })
                );
                setCurrentPageSize(pageSize);
                setRows(updatedData);
                setPaginationInfo({
                    currentPage: resp?.data?.currentPage,
                    totalPage: resp?.data?.totalPage,
                    totalRecords: resp?.data?.totalRecords,
                });
                listRef.current.stopEditing();
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoader(false);
        }
    }

    const createHandler = async rowData => {
        try {
            setLoader(true);
            const reqBody = getCreateUpdateReqBody(rowData);
            const res = await fetchAllPostPromisedData(
                endpoint?.TransferValidationConfig?.create,
                reqBody,
                'post'
            );
            if (res?.code === 200) {
                successToast(res?.message);
                fetchList({}, 0, currPageSize, false);
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoader(false);
        }
    }

    const updateHandler = async (rowData) => {
        try {
            setLoader(true);
            const reqBody = getCreateUpdateReqBody(rowData);
            const res = await fetchAllPostPromisedData(
                `${endpoint.TransferValidationConfig.update}`,
                reqBody,
                'put'
            );
            if (res?.code === 200) {
                successToast(res?.message);
                fetchList({}, paginationInfo?.currentPage, currPageSize, false);
            }
            else {
                failureToast(res?.message);
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoader(false);

        }
    }

    useEffect(() => {
        Object.keys(dropdownData)?.length > 0 && fetchList()
    }, [dropdownData]);

    const nextButtonHandler = (newPage, currPageSize) => {
        const itemVal = updateRequest(globalFilter);
        fetchList(itemVal, newPage, currPageSize, false);
    };

    const toggleStatusHandler = async rowData => {
        setLoader(true);
        setLoader(false);
    }

    return (
        <div className={`remove-container-top-space`}>
            {(dropdownDataLoading || loader) && (
                <ALoader position="fixed" />
            )}
            <div className={`${styles['page-container']}`}>
                <div className="d-flex justify-content-between align-items-start">
                    <div className={`${styles['header-bar']}`}>
                        {/* <BackIcon onClick={() => history.goBack()} /> */}
                        <div className="ml-3 heading-4 color-dark">
                            {isBranchLevelConfig
                                ? 'BU Level Configuration'
                                : 'PAN India Configuration'
                            }
                        </div>
                    </div>

                    <div className="d-flex justify-content-between">
                        <APopover
                            buttonComponent={(onClick, styles) => (
                                <AButton
                                    className="tiny-semi-bold color-dark"
                                    onClick={onClick}
                                    updatedStyle={{
                                        minWidth: "61px",
                                        ...(filterCount > 0
                                            ? {
                                                border: "1px solid #00B0F5",
                                                color: "#00B0F5",
                                            }
                                            : styles),
                                    }}
                                >
                                    Filter {filterCount > 0 && <>( {filterCount} )</>}
                                </AButton>
                            )}
                            menuComponent={(closePopup) => (
                                <FilterForm
                                    closePopup={closePopup}
                                    dropdownData={dropdownData}
                                    globalFilter={globalFilter}
                                    filterCount={filterCount}
                                    setFilterCount={setFilterCount}
                                    setGlobalFilter={setGlobalFilter}
                                    applyFilterHandler={applyFilterHandler}
                                    isBranchLevelConfig={!!isBranchLevelConfig}

                                />
                            )}
                        />

                        {checkPermission(userPermissions, 'C') && <AButton
                            // updatedStyle={{ fontWeight: 600 }}
                            onClick={() => listRef?.current?.addNewRow()}
                            variant="primary_filled"
                            size="xs"
                        >
                            + Add configuration
                        </AButton>
                        }
                    </div>

                </div>
                <ListComponent
                    currentPage={paginationInfo?.currentPage}
                    currPageSize={currPageSize}
                    ref={listRef}
                    rows={rows}
                    loader={loader}
                    dropdown={dropdownData}
                    createHandler={createHandler}
                    updateHandler={updateHandler}
                    toggleStatusHandler={toggleStatusHandler}
                    //deleteHandler={deleteHandler}
                    nextButtonHandler={nextButtonHandler}
                    rowCount={paginationInfo.totalRecords}
                    isNew={isNew}
                    setIsNew={setIsNew}
                    isBranchLevelConfig={isBranchLevelConfig}
                />
            </div>
        </div>

    )
}

export default TransferValidationConfig;